const value = Object.freeze({
  OrderAndEquipmentInfo: 0,
  StatusHistory: 1,
  LogHistory: 2,
})
export default value
